import React, {HTMLAttributes, RefAttributes} from "react";
import {IonRadio, IonRadioGroup} from "@ionic/react";
import {JSX} from "react/jsx-runtime";
import IntrinsicAttributes = JSX.IntrinsicAttributes;
import {StyleReactProps} from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import {
    IFloatFormItemProps,
    IFormItemElement,
    IIntFormItemProps,
    IStringFormItemProps, TextFormItem
} from "../model/FormModel";
import ErrorWrapperFE from "../form-element/ErrorWrapperFE";
import SimpleChoice from "../../../../ts/common/SimpleChoiceVO";

interface IProps extends IFormItemElement
{
    choiceList?:SimpleChoice[];
    formItemProps:IStringFormItemProps|IFloatFormItemProps|IIntFormItemProps;
    elementProps?: IntrinsicAttributes & React.ComponentProps<typeof IonRadioGroup> & Omit<HTMLAttributes<HTMLIonRadioGroupElement>, "style"> & StyleReactProps & RefAttributes<typeof IonRadioGroup>
}

const RadioGroupFIE = (props: IProps) =>
{
    let {
        form,
        formItemProps,
        label,
        onItemChange,
        instructions,
        choiceList,
        elementProps
    } = props;

    const formItem = form.requireFormItem(formItemProps, formItemProps.type ?? "string", true) as TextFormItem;

    label = label ?? formItem.name;
    label = label || !formItem.required ? label : " ";

    const onChange = (event:CustomEvent) => {
        if(!formItem.setValue(event.detail.value ?? "")){
            return;
        }

        if(onItemChange){
            onItemChange(formItem.itemID)
        } else if(onItemChange !== null){
            form.onFormItemChange(formItem.itemID)
        }
    }
    return <div className={form.isFormItemHidden(formItem) ? "d-none" : ""}>
        <ErrorWrapperFE
            formItem={formItem}
        >

            <fieldset>
                <div className="row">
                    {!!label &&
                        <div className="col-12">
                            <legend
                                className={"form-item-label" + (formItem.required ? " required" : "")}
                            >
                                {label}
                            </legend>
                        </div>
                    }
                    {!!instructions && (
                        <div className="col-12">
                            <span className="instructions">{instructions}</span>
                        </div>
                    )}
                    <IonRadioGroup
                        {...elementProps}
                        data-form-item-id={formItem.itemID}
                        value={formItem.value}
                        name={formItem.itemID}
                        onIonChange={onChange}
                    >
                        <div className="row d-flex align-items-start row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
                            {(choiceList ?? []).map((choice, index) =>
                            {
                                return <div
                                    key={index}
                                    className="col"
                                >

                                    <div className="radio_check-el">
                                        <IonRadio
                                            value={choice.id}
                                        >
                                            {choice.name}
                                        </IonRadio>
                                    </div>
                                </div>
                            })}
                        </div>
                    </IonRadioGroup>
                </div>
            </fieldset>
        </ErrorWrapperFE>
    </div>;
}

export default RadioGroupFIE;